import styles from './Css/Banner.module.css';

const Banner = ({ 
  imagePath , // Image from public folder
  altText
}) => {
  return (
    <div className={styles.banner}>
      <div className={styles.imageContainer}>
        <img 
          src={imagePath} 
          alt={altText} 
          className={styles.image}
        />
      </div>
    </div>
  );
};

export default Banner;